// export const environment = {
//   production: false,
//   BASE_URL: 'http://localhost:3000',
//   SOCKET_URL: 'http://localhost:3000',
// }

// export const environment = {
//   production: false,
//   BASE_URL: 'https://sms-portal.doer.com.bd/api',
//   SOCKET_URL: 'https://sms-portal.doer.com.bd/api',
// }

export const environment = {
  production: false,
  STORAGE_SECRET_KEY:
    'sms-servicesms-servicesms-servicesms-servicesms-servicesms-servicesms-servicesms-service',
  BASE_URL: 'https://dev-sms-portal.doer.school/api',
  SOCKET_URL: 'https://dev-sms-portal.doer.school/api',
}
